import { isEmpty } from '@utils/validationUtils';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IBusinessPartner, IProposalDrawerValues, IProposalLovs } from '.';

export const proposalDrawerInitialValues: IProposalDrawerValues = {
  businessPartnerRepeater: [
    {
      businessPartner: '',
      share: null,
    },
  ],
  line: '',
  subline: '',
  plan: '',
  policyCurrency: '',
  isGroup: 'No',
};

export const getSections = (
  data: IProposalDrawerValues = proposalDrawerInitialValues,
  lists: IProposalLovs,
  allowGroupPolicy: boolean
): IDynamicFormWidgetSection[] => [
  {
    sectionTitle: 'Business Partner(s)',
    inputs: {
      businessPartnerRepeater: {
        name: 'businessPartnerRepeater',
        title: '',
        type: FormFieldType.repeaterBox,
        addButtonText: '+ Add Additional Business Partner',
        dynamicAddButtonText: [
          '+ Add Secondary Business Partner',
          '+ Add Additional Business Partner',
        ],
        value: data?.businessPartnerRepeater,
        maxRepeaterLength: 3,
        minRepeaterLength: 1,
        inputs: {
          businessPartner: {
            name: 'businessPartner',
            title: 'Additional Business Partner',
            dynamicTitle: [
              'Primary Business Partner*',
              'Secondary Business Partner',
              'Additional Business Partner',
            ],
            placeholder: 'Type to search for business partners',
            type: FormFieldType.autocomplete,
            value: '',
            error: '',
            required: true,
            customValidator: (values) => {
              const businessPartnersIds = values.businessPartnerRepeater.map(
                (item: IBusinessPartner) => item.businessPartner
              );
              const isDuplicated = businessPartnersIds.some(
                (id: string, index: number) =>
                  businessPartnersIds.indexOf(id) !== index
              );
              return isDuplicated ? 'Business partner already selected' : '';
            },
          },
          share: {
            name: 'share',
            title: 'Share',
            dynamicTitle: ['Share*'],
            placeholder: 'Enter Share',
            type: FormFieldType.percentage,
            value: '',
            error: '',
            required: true,
            customValidator: (values) => {
              const totalShare = values.businessPartnerRepeater.reduce(
                (acc: number, item: any) => acc + parseFloat(item.share || 0),
                0
              );

              return totalShare !== 100
                ? 'Total Share should be equal to 100%'
                : '';
            },
          },
        },
      },
    },
  },
  {
    sectionTitle: 'Plan',
    inputs: {
      line: {
        name: 'line',
        title: 'Line',
        type: FormFieldType.select,
        placeholder: 'Line',
        value: data.line || '',
        selectOptions: lists.line,
        required: true,
      },
      subline: {
        name: 'subline',
        title: 'Subline',
        type: FormFieldType.select,
        placeholder: 'Subline',
        value: !isEmpty(data.subline) ? data.subline : '',
        required: true,
        selectOptions: lists.subline,
        hidden: isEmpty(data.line),
      },
      plan: {
        name: 'plan',
        title: 'Plan',
        type: FormFieldType.select,
        placeholder: 'Plan',
        value: !isEmpty(data.plan) ? data.plan : '',
        required: true,
        selectOptions: lists.plan,
        hidden: isEmpty(data.subline),
      },
      policyCurrency: {
        name: 'policyCurrency',
        title: 'Policy Currency',
        type: FormFieldType.select,
        placeholder: 'Policy Currency',
        value: data.policyCurrency || '',
        required: true,
        injectGlobalLov: {
          type: 'currency',
          value: 'Id',
          display: 'Title',
        },
      },
      isGroup: {
        name: 'isGroup',
        title: 'Group Policy',
        type: FormFieldType.select,
        placeholder: 'Group Policy',
        value: data.isGroup || '',
        selectOptions: lists.isGroup,
        required:
          allowGroupPolicy &&
          ['4', '50', '51', '3'].includes(
            getNumberBeforeHyphen(
              lists?.line?.[data?.line || '']?.toString()
            )?.toString()
          ),
        hidden: !(
          allowGroupPolicy &&
          ['4', '50', '51', '3'].includes(
            getNumberBeforeHyphen(
              lists?.line?.[data?.line || '']?.toString()
            )?.toString()
          )
        ),
      },
    },
  },
];

export function getNumberBeforeHyphen(inputString: any): number {
  const match = inputString?.toString()?.match(/^(\d+)\s*-/);
  return match ? parseInt(match[1], 10) : null;
}
